<template>
    <li @click="onclick" class="mc-btnSelectItem">
        <slot></slot>
    </li>
</template>
<script type="text/ecmascript-6">
    export default {
        name: 'mcBtnDropdownItem',
        props: {

        },
        data(){
            return {

            }
        },
        methods: {
            onclick(){
                this.$emit('click')
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/base-btn-dropdown-item.vue